import { MenuList } from "@mui/material";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SnippetFolderIcon from '@mui/icons-material/SnippetFolder';
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import BusinessIcon from '@mui/icons-material/Business';
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import OrganizationList from "../../organizations/components/OrganizationList";
import CreateProjectForm from "./CreateProjectForm";
import Box from "@mui/material/Box";
import ProjectList from "./ProjectList";
import * as React from "react";
import CreateNewButton from "../../../ui/CreateNewButton";
import Invites from "../../invites/components/Invites";
import { observer } from "mobx-react-lite";
import i18nStore from "../../../i18n/store";
import { useState } from "react";


const Tabs = {
    ProjectsTab: 0,
    OrganizationsTab: 1,
    InvitesTab: 2,
}

const ProjectsPage = observer(() => {
    const translations = i18nStore.getTranslations;
    const [openCreationModal, setOpenCreationModal] = useState<boolean>(false);
    const [selectedTab, setSelectedTab] = useState<number>(Tabs.ProjectsTab);

    return (
        <Box sx={{
            display: "flex",
            flexDirection: {xs: "column", md: "row"},
            justifyContent: {xs: "stretch", md: "center"},
        }}>
            <ProjectPageMenu selectedTab={selectedTab} setSelectedTab={setSelectedTab} />

            <Box sx={{ flexGrow: 1, px: 1 }}>
                {
                    selectedTab === Tabs.ProjectsTab &&
                    <Box>
                        <CreateProjectForm openCreationModal={openCreationModal} setOpenCreationModal={setOpenCreationModal} />
                        <CreateNewButton
                            onClick={() => setOpenCreationModal(true)}
                            text={translations.createProject}
                        />
                        <ProjectList />
                    </Box>
                }

                {selectedTab === Tabs.OrganizationsTab && <OrganizationList />}
                {selectedTab === Tabs.InvitesTab && <Invites />}
            </Box>
        </Box>
    );
});


export default ProjectsPage;


interface ProjectPageMenuProps {
    selectedTab: number;
    setSelectedTab: (index: number) => void;
}

function ProjectPageMenu(props: ProjectPageMenuProps) {
    const translations = i18nStore.getTranslations;

    return (
        <Paper sx={{ width: {xs: "100%", md: 320}, maxWidth: '100%' }} elevation={0}>
            <MenuList sx={{ py: 0 }}>
                <MenuItem
                    selected={props.selectedTab === Tabs.ProjectsTab}
                    onClick={() => props.setSelectedTab(Tabs.ProjectsTab)}
                >
                    <ListItemIcon>
                        <SnippetFolderIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>{translations.projects}</ListItemText>
                </MenuItem>

                {/*<MenuItem*/}
                {/*    selected={props.selectedTab === Tabs.OrganizationsTab}*/}
                {/*    onClick={() => props.setSelectedTab(Tabs.OrganizationsTab)}*/}
                {/*>*/}
                {/*    <ListItemIcon>*/}
                {/*        <BusinessIcon fontSize="small" />*/}
                {/*    </ListItemIcon>*/}
                {/*    <ListItemText>{translations._organizations.organizations}</ListItemText>*/}
                {/*</MenuItem>*/}

                <MenuItem
                    selected={props.selectedTab === Tabs.InvitesTab}
                    onClick={() => props.setSelectedTab(Tabs.InvitesTab)}
                >
                    <ListItemIcon>
                        <PersonAddIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>{translations._invites.invites}</ListItemText>
                </MenuItem>
            </MenuList>
        </Paper>
    );
}
